<template>
    <div>
        <div class="subtitle font-bold">Thông tin cấp lệnh</div>
        <div class="row pb-2 justify-space-between align-center">
            <div class="xs5">Người cấp lệnh</div>
            <div class="pl-2 font-bold">
                {{ model.nguoiCapLenh }}
            </div>
        </div>
        <div class="row pb-2 justify-space-between align-center">
            <div class="xs5">Thời gian cấp lệnh</div>
            <div class="pl-2 font-bold">
                {{ moment(model.thoiGianCapLenh).format("HH:mm DD/MM/yyyy") }}
            </div>
        </div>
    </div>
</template>
<script>
import LenhDienTu from "../../../../class/LenhDienTu";
export default {
    components: {},
    props: {
        model: {
            type: Object,
            default: ()=>new LenhDienTu().get(),
        },
    },
    data() {
        return {};
    },
    methods: {},
    created() {},
    mounted() {},
};
</script>
<style scoped>
</style>
<style lang='scss' scoped>
</style>